import { ListItem, space, tok, Typography } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

export const FilterLabel = styled(Typography)`
  font-size: ${tok('primitives_font_size_body_m')}px;
  font-weight: 600;
  line-height: 125%;
  color: ${tok('semantics_content_color')};
`
export const FilterDescription = styled(Typography)`
  font-size: ${tok('primitives_font_size_body_m')}px;
  font-weight: 500;
  line-height: 150%;
  color: ${tok('semantics_content_color')};
`
export const FilterOptionValue = styled(ListItem.Label)`
  font-size: ${tok('primitives_font_size_body_m')}px;
  font-weight: 500;
  line-height: 150%;
  color: ${tok('semantics_content_color')};
`
export const FilterOptionHelpText = styled(Typography)`
  font-size: ${tok('primitives_font_size_body_s')}px;
  font-weight: 500;
  line-height: 120%;
  color: ${tok('semantics_content_secondary_color')};
`
export const FilterOptionPrice = styled(Typography)`
  font-size: ${tok('primitives_font_size_body_s')}px;
  font-weight: 500;
  line-height: 120%;
  color: ${tok('semantics_content_secondary_color')};
  white-space: nowrap;
`
export const FilterItemOption = styled(ListItem.Root)`
  padding: ${space('primitives_space_12')};
`
export const FilterItemOptionControl = styled(ListItem.Control)`
  align-self: self-start;
`
